import { createLogger } from 'redux-logger'
import thunk from 'redux-thunk'

const middlewares = [thunk]

if (process.env.NODE_ENV === 'development') {
  const logger = createLogger({ level: 'info', collapsed: true })
  middlewares.push(logger)
}

export default middlewares



// WEBPACK FOOTER //
// ./src/reducers/middlewares.js